import React from 'react';
import SkeletonLoader from './Skeleton';
import GenericCard, { GenericCardProps } from '../Cards/GenericCard';
import { Column, ColumnItem } from '../../foundations/ColumnLayout';
import ContentRow from '../Cards/ContentRow';

export type CardSkeletonProps = {} & GenericCardProps;

const RowItem = () => (
  <ContentRow label={<SkeletonLoader widthClass="w-32 md:w-40" />}>
    <SkeletonLoader widthClass="w-40 md:w-60" />
  </ContentRow>
);

const CardSkeleton = (props: CardSkeletonProps) => {
  if (props.children) {
    return (
      <>
        <GenericCard {...props}>{props.children}</GenericCard>
      </>
    );
  }
  return (
    <>
      <GenericCard {...props}>
        <Column>
          <ColumnItem xs={12} lg={10}>
            <RowItem />
          </ColumnItem>
        </Column>
      </GenericCard>
    </>
  );
};

CardSkeleton.RowItem = RowItem;
export default CardSkeleton;
